// config/themeConfig.js

const themes = {
  default: {
    // Main colors
    background: 'linear-gradient(135deg, #DBE2EF 0%, #112D4E 100%)',
    textColor: '#2c3e50',
    
    // Header
    headerBackground: 'linear-gradient(135deg, #334455 0%, #334455 100%)',
    headerTextColor: '#ffffff',
    
    // Cards and containers
    cardBackground: 'rgba(255, 255, 255, 0.95)',
    businessItemBackground: 'rgba(52, 152, 219, 0.1)',
    businessItemHoverBackground: 'rgba(52, 152, 219, 0.2)',
    
    // Colors
    primaryColor: '#3F72AF',
    primaryColorHover: '#2980b9',
    secondaryColor: '#95a5a6',
    secondaryColorHover: '#7f8c8d',
    accentColor: '#e74c3c',
    
    // Text colors
    businessNameColor: '#2c3e50',
    businessDetailsColor: '#7f8c8d',
    mutedTextColor: '#95a5a6',
    linkColor: '#3498db',
    
    // Direction specific
    directionSectionBackground: 'rgba(46, 204, 113, 0.1)',
    directionBorderColor: '#2ecc71',
    directionTitleColor: '#27ae60',
    
    // Borders and shadows
    borderColor: 'rgba(189, 195, 199, 0.3)',
    shadowSmall: '0 2px 4px rgba(0,0,0,0.1)',
    shadowMedium: '0 4px 8px rgba(0,0,0,0.15)',
    shadowLarge: '0 8px 16px rgba(0,0,0,0.2)',
    
    // Border radius
    borderRadius: {
      small: '4px',
      medium: '8px',
      large: '12px',
    },
    
    // Typography
    fontFamily: "'Assistant','Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontWeight: {
      normal: '400',
      medium: '500',
      bold: '700',
    }
  },

  modern: {
    // Main colors
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    textColor: '#1a202c',
    
    // Header
    headerBackground: 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)',
    headerTextColor: '#ffffff',
    
    // Cards and containers
    cardBackground: '#ffffff',
    businessItemBackground: 'rgba(99, 102, 241, 0.1)',
    businessItemHoverBackground: 'rgba(99, 102, 241, 0.2)',
    
    // Colors
    primaryColor: '#6366f1',
    primaryColorHover: '#4f46e5',
    secondaryColor: '#6b7280',
    secondaryColorHover: '#4b5563',
    accentColor: '#f59e0b',
    
    // Text colors
    businessNameColor: '#1f2937',
    businessDetailsColor: '#6b7280',
    mutedTextColor: '#9ca3af',
    linkColor: '#6366f1',
    
    // Direction specific
    directionSectionBackground: 'rgba(16, 185, 129, 0.1)',
    directionBorderColor: '#10b981',
    directionTitleColor: '#047857',
    
    // Borders and shadows
    borderColor: 'rgba(209, 213, 219, 0.5)',
    shadowSmall: '0 1px 3px rgba(0,0,0,0.1)',
    shadowMedium: '0 4px 6px rgba(0,0,0,0.1)',
    shadowLarge: '0 10px 15px rgba(0,0,0,0.1)',
    
    // Border radius
    borderRadius: {
      small: '6px',
      medium: '8px',
      large: '12px',
    },
    
    // Typography
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: {
      normal: '400',
      medium: '500',
      bold: '600',
    }
  },

  dark: {
    // Main colors
    background: 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)',
    textColor: '#e2e8f0',
    
    // Header
    headerBackground: 'linear-gradient(135deg, #2d3748 0%, #4a5568 100%)',
    headerTextColor: '#ffffff',
    
    // Cards and containers
    cardBackground: 'rgba(45, 55, 72, 0.95)',
    businessItemBackground: 'rgba(74, 85, 104, 0.3)',
    businessItemHoverBackground: 'rgba(74, 85, 104, 0.5)',
    
    // Colors
    primaryColor: '#63b3ed',
    primaryColorHover: '#4299e1',
    secondaryColor: '#a0aec0',
    secondaryColorHover: '#718096',
    accentColor: '#f56565',
    
    // Text colors
    businessNameColor: '#f7fafc',
    businessDetailsColor: '#cbd5e0',
    mutedTextColor: '#a0aec0',
    linkColor: '#63b3ed',
    
    // Direction specific
    directionSectionBackground: 'rgba(72, 187, 120, 0.2)',
    directionBorderColor: '#48bb78',
    directionTitleColor: '#68d391',
    
    // Borders and shadows
    borderColor: 'rgba(74, 85, 104, 0.5)',
    shadowSmall: '0 2px 4px rgba(0,0,0,0.3)',
    shadowMedium: '0 4px 8px rgba(0,0,0,0.4)',
    shadowLarge: '0 8px 16px rgba(0,0,0,0.5)',
    
    // Border radius
    borderRadius: {
      small: '4px',
      medium: '8px',
      large: '12px',
    },
    
    // Typography
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontWeight: {
      normal: '400',
      medium: '500',
      bold: '700',
    }
  },

  professional: {
    // Main colors
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    textColor: '#2d3748',
    
    // Header
    headerBackground: 'linear-gradient(135deg, #2b6cb0 0%, #2c5282 100%)',
    headerTextColor: '#ffffff',
    
    // Cards and containers
    cardBackground: '#ffffff',
    businessItemBackground: 'rgba(43, 108, 176, 0.1)',
    businessItemHoverBackground: 'rgba(43, 108, 176, 0.15)',
    
    // Colors
    primaryColor: '#2b6cb0',
    primaryColorHover: '#2c5282',
    secondaryColor: '#718096',
    secondaryColorHover: '#4a5568',
    accentColor: '#d69e2e',
    
    // Text colors
    businessNameColor: '#2d3748',
    businessDetailsColor: '#4a5568',
    mutedTextColor: '#718096',
    linkColor: '#2b6cb0',
    
    // Direction specific
    directionSectionBackground: 'rgba(56, 178, 172, 0.1)',
    directionBorderColor: '#38b2ac',
    directionTitleColor: '#2c7a7b',
    
    // Borders and shadows
    borderColor: 'rgba(226, 232, 240, 0.8)',
    shadowSmall: '0 1px 3px rgba(0,0,0,0.08)',
    shadowMedium: '0 4px 6px rgba(0,0,0,0.1)',
    shadowLarge: '0 10px 15px rgba(0,0,0,0.1)',
    
    // Border radius
    borderRadius: {
      small: '4px',
      medium: '6px',
      large: '8px',
    },
    
    // Typography
    fontFamily: "'Source Sans Pro', Arial, sans-serif",
    fontWeight: {
      normal: '400',
      medium: '600',
      bold: '700',
    }
  },

  vibrant: {
    // Main colors
    background: 'linear-gradient(135deg, #ff9a8b 0%, #a8e6cf 50%, #ffd3a5 100%)',
    textColor: '#2c3e50',
    
    // Header
    headerBackground: 'linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 100%)',
    headerTextColor: '#ffffff',
    
    // Cards and containers
    cardBackground: 'rgba(255, 255, 255, 0.9)',
    businessItemBackground: 'rgba(255, 107, 107, 0.15)',
    businessItemHoverBackground: 'rgba(255, 107, 107, 0.25)',
    
    // Colors
    primaryColor: '#ff6b6b',
    primaryColorHover: '#ff5252',
    secondaryColor: '#4ecdc4',
    secondaryColorHover: '#26d0ce',
    accentColor: '#feca57',
    
    // Text colors
    businessNameColor: '#2c3e50',
    businessDetailsColor: '#34495e',
    mutedTextColor: '#7f8c8d',
    linkColor: '#ff6b6b',
    
    // Direction specific
    directionSectionBackground: 'rgba(78, 205, 196, 0.2)',
    directionBorderColor: '#4ecdc4',
    directionTitleColor: '#26d0ce',
    
    // Borders and shadows
    borderColor: 'rgba(189, 195, 199, 0.4)',
    shadowSmall: '0 2px 4px rgba(0,0,0,0.1)',
    shadowMedium: '0 4px 8px rgba(0,0,0,0.15)',
    shadowLarge: '0 8px 16px rgba(0,0,0,0.2)',
    
    // Border radius
    borderRadius: {
      small: '8px',
      medium: '12px',
      large: '16px',
    },
    
    // Typography
    fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: {
      normal: '400',
      medium: '500',
      bold: '600',
    }
  }
};

export const getThemeConfig = (themeName = 'default') => {
  return themes[themeName] || themes.default;
};

export const availableThemes = Object.keys(themes);

export default themes;